import { PqrFilter } from '../../../../../shared/types/modules/pqr';

export const initialValues: PqrFilter = {
    caseId: '',
    pqrId: '',
    sfcId: '',
    document: '',
    name: '',
    receptionChannel: [],
    half: [],
    type: [],
    branch: [],
    incharge: [],
    reconsideration: [],
    survey: '',
    correspondenceFiling: '',
    status: [],
    reception: '',
    keywords: '',
    startCreatedAt: undefined,
    endCreatedAt: undefined,
};
